export const PROVINCES = {
  DOLNOSLASKIE: 'DOLNOSLASKIE',
  KUJAWSKO_POMORSKIE: 'KUJAWSKO_POMORSKIE',
  LUBELSKIE: 'LUBELSKIE',
  LUBUSKIE: 'LUBUSKIE',
  LODZKIE: 'LODZKIE',
  MALOPOLSKIE: 'MALOPOLSKIE',
  MAZOWIECKIE: 'MAZOWIECKIE',
  OPOLSKIE: 'OPOLSKIE',
  PODKARPACKIE: 'PODKARPACKIE',
  PODLASKIE: 'PODLASKIE',
  POMORSKIE: 'POMORSKIE',
  SLASKIE: 'SLASKIE',
  SWIETOKRZYSKIE: 'SWIETOKRZYSKIE',
  WARMINSKO_MAZURSKIE: 'WARMINSKO_MAZURSKIE',
  WIELKOPOLSKIE: 'WIELKOPOLSKIE',
  ZACHODNIOPOMORSKIE: 'ZACHODNIOPOMORSKIE',
} as const

export type Province = keyof typeof PROVINCES



// WEBPACK FOOTER //
// ./src/API/Region/Region.Enums.ts